<template lang='pug'>
  article.modals.wrapper.component
    slot
      slot(name='close')
        close-button( @click.native='$emit("close")' )

      header
        slot(name='header')

      section
        slot(name='contents')

      footer
        slot(name='footer')
</template>

<script>
  import CloseButton from '@/components/buttons/close'

  export default {
    name: 'modals.wrapper',

    components: {
      CloseButton
    }
  }
</script>

<style scoped lang="stylus">
  .wrapper
    background white
    border-radius 5px
    min-width 720px
    max-width 960px
    position relative
    border 1px solid orange
    @media( max-width: 480px )
      min-width 0
    &.max-640
      max-width 640px
    &.max-800
      max-width 800px
    &.max
      max-width none
      width 96%
    header
      padding 16px 32px
      background rgba( 0 0 0 .1 )
      border-bottom 1px solid rgba( 0 0 0 .25 )

    footer
      border-top 1px solid rgba( 0 0 0 .25 )
    
    header, footer
      box-shadow var(--shadow-box-shallow)

    section
      padding 20px
      max-height calc( 100vh - 400px )
      overflow-y auto
    
    .close
      position absolute
      right 15px
      top 15px
      background white
</style>
